<template lang="html">
  <vtake-interval-photos
    v-if="!timeIsOverFlag"
    :interval="intervalToTakePhotos"
    @on_started="fetch"
    @set_photo="set_photo">
    <NoWebcam slot="disabled"/>
    <div class="test-container" slot="enabled" v-if="test">
      <timer :time="time" :timeLimit="timeLimit" @timeIsOver="timeIsOver"></timer>
      <h3 class="test-title"> {{ $tr('videoInterview.test.title') }} {{ interview.vacancy.name }} </h3>
      <div class="test-groups" v-if="groups">
        <Group v-for="(group, i) in groups" :key="i" :group="group" :answerChange="answerChange"/>
      </div>
      <div v-else>
        <!-- no groups message -->
      </div>
      <div class="end-video-wrapper">
        <vbutton
          label="videoInterview.test.endTest"
          @click="endTestButtonClick" />
      </div>
    </div>
    <vpreloader slot="enabled" v-else/>
  </vtake-interval-photos>
  <TimeIsOver v-else @complete="complete"/>
</template>

<script>
  import Group from './Group.vue'
  import Timer from './Timer.vue'
  import NoWebcam from '@/components/interview/equipmentCheck/NoWebcam.vue';
  import TimeIsOver from './TimeIsOver.vue'

  export default {
    name: 'process-interview-test-container',

    props: {
      interview: Object
    },

    components: {
      Group,
      Timer,
      NoWebcam,
      TimeIsOver
    },

    data () {
      return {
        webCamAvailable: false,
        timeIsOverFlag: false
      }
    },

    methods: {
      fetch () {
        this.$store.dispatch('process/shlumberger/interview/test/fetch')
      },

      endTest () {
        this.$store.dispatch('process/shlumberger/interview/test/end')
      },

      set_photo (picture) {
        this.$store.dispatch('process/shlumberger/interview/test/uploadPicturePublic', {
          picture
        });
      },

      // push to parent notification about stage change
      complete () {
        this.$emit('complete')
      },

      endTestButtonClick () {
        this.$store.dispatch('process/shlumberger/interview/test/end')
        .then(this.complete)
        .catch(err => console.log(err))
      },

      answerChange (question, answer) {
        this.$store.dispatch('process/shlumberger/interview/test/saveAnswer',
          { question, answer }
        )
      },

      timeIsOver () {
        this.endTest()
        this.timeIsOverFlag = true
      }
    },

    computed: {
      test () {
        return this.$store.getters['process/shlumberger/interview/test/one']
      },

      groups () {
        return this.test ? this.test.groups : []
      },

      time () {
        return new Date(this.test && this.test.date_start ? this.test.date_start : void 0)
      },

      timeLimit () {
        return this.test && this.test.time_limit ? this.test.time_limit : void 0
      },

      intervalToTakePhotos () {
        return this.$store.getters['process/shlumberger/interview/test/intervalToTakePhotos']
      }
    },

    beforeMount () {
      // set ru locale as it should use only it
      this.$store.dispatch('locale/change', 'ru')
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.test-container {
  width: 820px;
  font-size: 16px;
  padding-top: 21px;
  // font-family: Roboto;
  padding-bottom: 182px;
}

.test-title {
  text-align: center;
  padding-bottom: 34px;
}

.question-number {
  width: 30px;
  font-size: 24px;
  font-weight: bold;
  color: $green;
  padding-right: 18px;
}

.question-body {
  font-size: 18px;
}

.answers-container {
  flex-direction: row;
}

.answer-container {
  display: flex;
  width: 100%;
}

.answer-body {
  width: 100%;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 8px;
}

.answer-body_selected {
  background-color: rgb(235, 248, 233);
}

.open-answer:first-child {
  padding-top: 19px !important;
}

.answer-container:first-child {
  padding-top: 29px;
}

.answer-container:not(:first-child) {
  padding-top: 24px;
}

hr {
  padding-top: 21px;
}

.checkbox-area {
  width: 35px;
  padding-top: 7px;
  padding-right: 18px;
}

.end-video-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.end-video-text {
  padding-top: 22px;
  width: 310px;
  color: #aaa;
  font-size: 14px;
  text-align: center;
}

.btn-finish {
  width: 250px;
}
</style>
